import Image from "next/image";
import styles from "./StoryblokImage.module.css";

type StoryBlokImageProps = {
	media: any;
} & StoryblokImageSizes;

type StoryblokImageSizes =
	| {
			fill?: false;
			sizes?: string;
			width: number | `${number}`;
			height: number | `${number}`;
			customAspect?: boolean;
	  }
	| {
			fill: true;
			sizes: string;
			width: undefined;
			height: undefined;
			customAspect?: boolean;
	  };

export const StoryblokImage = ({
	media,
	width,
	height,
	sizes,
	fill,
	customAspect,
}: StoryBlokImageProps) => (
	<Image
		src={media.file}
		alt={media.alt}
		fill={fill}
		width={width}
		height={height}
		className={styles.image}
		sizes={sizes}
		style={{
			objectPosition: media.focus,
			aspectRatio: !customAspect ? `${media.width}/${media.height}` : undefined,
		}}
	/>
);
